import cookies from "js-cookie"

const COOKIE_NAME = process.env.GATSBY_GDPR_COOKIE || "farmers-gdpr-gtag"

export const hasGdprCookie = () => cookies.get(COOKIE_NAME)
export const setGdprCookie = () => cookies.set(COOKIE_NAME, 1)
